import { configureStore } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import authReducer from "./authSlice";
import agentsReducer from "./agentSlice";
import userSlice from "./userSlice";
import filtersReducer from "./filtersSlice";
import contractDashboardReducer from "./contractDashboardSlice";
import procurementDashboardReducer from "./procurementDashboardSlice";
import feedbackReducer from "./feedbackSlice";
import userRolesReducer from "./userRolesSlice";
import chatHistoryReducer from "./chatHistorySlice";
import maintenanceReducer from "./maintenanceSlice";
import interviewHostReducer from "./interviewHostSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    agents: agentsReducer,
    user: userSlice,
    filters: filtersReducer,
    contractDashboard: contractDashboardReducer,
    procurementDashboard: procurementDashboardReducer,
    feedback: feedbackReducer,
    userRoles: userRolesReducer,
    chatHistory: chatHistoryReducer,
    maintenance: maintenanceReducer,
    interviewHost: interviewHostReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore MSAL account objects which contain non-serializable Maps
        ignoredActions: ['auth/setUser'],
        ignoredPaths: ['auth.user'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export default store;
